
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jRzjr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c94fd95a546b3b9a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $1qbKn = parcelRequire("1qbKn");

var $9F3VB = parcelRequire("9F3VB");

var $dUPdT = parcelRequire("dUPdT");

var $gfDeC = parcelRequire("gfDeC");

var $aWMnb = parcelRequire("aWMnb");

var $607xL = parcelRequire("607xL");

var $173Wl = parcelRequire("173Wl");

var $lqBEF = parcelRequire("lqBEF");
const $c94fd95a546b3b9a$var$errorBoundaryId = 'pluggable-items-entrypoint';
const $c94fd95a546b3b9a$var$PluggableItems = ()=>{
    const [, { closeApps: closeApps }] = (0, $9F3VB.useForgeApps)();
    const isRegistered = (0, $eJOHy.useRef)(false);
    const registerModalDialogAnalytics = (0, $aWMnb.useRegisterModalDialogAnalytics)();
    const registerModalDialogAnalyticsOnce = (0, $eJOHy.useCallback)(()=>{
        if (!isRegistered.current) {
            registerModalDialogAnalytics();
            isRegistered.current = true;
        }
    }, [
        isRegistered,
        registerModalDialogAnalytics
    ]);
    (0, $aWMnb.useModalDialogCleanupEffect)();
    (0, $aWMnb.useInlineDialogZIndexOverrideLayoutEffect)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: $c94fd95a546b3b9a$var$errorBoundaryId,
        packageName: "jiraIssueNavigatorActionPluggableItems",
        teamName: "empanada",
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $173Wl.PluggableItemsFilterButton), {
                isDisabled: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
                id: $c94fd95a546b3b9a$var$errorBoundaryId,
                error: error
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfDeC.PluggableItemsCacheProvider), {
        onDataChanged: closeApps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dUPdT.DropdownTrigger), {
        entryPoint: (0, $607xL.appsButtonEntryPoint),
        errorFallback: ({ error: error })=>{
            // Throw error back up the stack to be caught and logged by the JSErrorBoundary
            throw error;
        },
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $173Wl.PluggableItemsFilterButton), {
                ...triggerProps,
                onClick: (...onClickProps)=>{
                    registerModalDialogAnalyticsOnce();
                    triggerProps.onClick?.(...onClickProps);
                }
            }),
        testId: "issue-navigator-action-pluggable-items.ui.filter-button",
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqBEF.IssueNavigatorActionRuntimeContainer), null));
};
const $c94fd95a546b3b9a$var$PluggableItemsWithForge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9F3VB.ForgeAppsContainer), {
        scope: "issue-navigator-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c94fd95a546b3b9a$var$PluggableItems, null));
var $c94fd95a546b3b9a$export$2e2bcd8739ae039 = $c94fd95a546b3b9a$var$PluggableItemsWithForge;

});
parcelRegister("9F3VB", function(module, exports) {
$parcel$export(module.exports, "ForgeAppsContainer", () => $590cae63d5fa5058$export$9d26afcb39445b8e);
$parcel$export(module.exports, "useForgeApps", () => $590cae63d5fa5058$export$a48819842c5a2f15);
$parcel$export(module.exports, "useIsAppLoading", () => $590cae63d5fa5058$export$24db0add8de543af);
$parcel$export(module.exports, "useIsAnyAppLoading", () => $590cae63d5fa5058$export$f65d61db50b49f3);

var $aXKmr = parcelRequire("aXKmr");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $590cae63d5fa5058$export$9d26afcb39445b8e = (0, $6E16M.createContainer)();
const $590cae63d5fa5058$var$actions = {
    openApp: (appId, extension, action, extensionData = {})=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: [
                    ...openedApps.filter((app)=>app.id !== appId || app.action !== action),
                    {
                        id: appId,
                        extension: extension,
                        extensionData: extensionData,
                        action: action,
                        uuid: (0, $aXKmr.v4)(),
                        isLoading: true
                    }
                ]
            });
        },
    setAppLoaded: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.map((app)=>app.id === appId && app.action === action && app.isLoading ? {
                        ...app,
                        isLoading: false
                    } : app)
            });
        },
    closeApps: ()=>({ setState: setState })=>{
            setState({
                openedApps: []
            });
        },
    closeApp: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.filter((app)=>app.id !== appId || app.action !== action)
            });
        }
};
const $590cae63d5fa5058$var$Store = (0, $GtRbT.createStore)({
    containedBy: $590cae63d5fa5058$export$9d26afcb39445b8e,
    initialState: {
        openedApps: []
    },
    actions: $590cae63d5fa5058$var$actions
});
const $590cae63d5fa5058$export$a48819842c5a2f15 = (0, $iJq0l.createHook)($590cae63d5fa5058$var$Store);
const $590cae63d5fa5058$var$isAppLoading = (state, { appId: appId, action: action })=>{
    return state.openedApps.some((app)=>app.id === appId && app.action === action && app.isLoading);
};
const $590cae63d5fa5058$export$24db0add8de543af = (0, $iJq0l.createHook)($590cae63d5fa5058$var$Store, {
    selector: $590cae63d5fa5058$var$isAppLoading
});
const $590cae63d5fa5058$var$isAnyAppLoading = (state)=>state.openedApps.some((app)=>app.isLoading);
const $590cae63d5fa5058$export$f65d61db50b49f3 = (0, $iJq0l.createHook)($590cae63d5fa5058$var$Store, {
    selector: $590cae63d5fa5058$var$isAnyAppLoading
});

});

parcelRegister("dUPdT", function(module, exports) {
$parcel$export(module.exports, "DropdownTrigger", () => $c3382dd48f500117$export$e7eb525bc415b4b4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kmlzw = parcelRequire("kmlzw");

var $5CSKW = parcelRequire("5CSKW");

var $7rjYb = parcelRequire("7rjYb");

var $5lAAn = parcelRequire("5lAAn");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $dy5PQ = parcelRequire("dy5PQ");

var $lBsyH = parcelRequire("lBsyH");

var $4Gyvo = parcelRequire("4Gyvo");
const $c3382dd48f500117$var$emptyEntryPointParams = {};
const $c3382dd48f500117$var$emptyEntryPointProps = {};
function $c3382dd48f500117$export$e7eb525bc415b4b4({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, ...dropdownProps }) {
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [children, setChildren] = (0, $eJOHy.useState)(null);
    const handleOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsOpen(isOpen);
    }, []);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $c3382dd48f500117$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        setChildren(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $gt9Am.jsx)($c3382dd48f500117$var$LoadingState, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $c3382dd48f500117$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setChildren,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        onError
    ]);
    const triggerRef = (0, $dy5PQ.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const popupTrigger = (0, $eJOHy.useCallback)((triggerProps)=>{
        const mergedRef = (0, $kmlzw.mergeRefs)([
            triggerRef,
            triggerProps.triggerRef
        ]);
        if (typeof trigger === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
            ...triggerProps,
            ref: mergedRef,
            isSelected: isOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    ...iconProps,
                    size: "small"
                }),
            testId: dropdownProps.testId && `${dropdownProps.testId}--trigger`,
            "aria-label": dropdownProps.label,
            children: trigger
        });
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            triggerRef: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        isOpen,
        dropdownProps.label,
        dropdownProps.testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        ...dropdownProps,
        onOpenChange: handleOpenChange,
        trigger: popupTrigger,
        shouldFitContainer: (0, $eGOwo.fg)('should-render-to-parent-should-be-true-uip-applica') ? false : undefined,
        shouldRenderToParent: (0, $eGOwo.fg)('should-render-to-parent-should-be-true-uip-applica'),
        children: children
    });
}
const $c3382dd48f500117$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $c3382dd48f500117$var$LoadingState() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $c3382dd48f500117$var$spinnerContainerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            size: "small"
        })
    });
}

});

parcelRegister("gfDeC", function(module, exports) {
$parcel$export(module.exports, "PluggableItemsCacheContext", () => $84e95ca7fc7a04c7$export$884805f5de744f77);
$parcel$export(module.exports, "PluggableItemsCacheProvider", () => $84e95ca7fc7a04c7$export$f2618be54b96efae);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $84e95ca7fc7a04c7$var$initialResponse = {
    data: undefined,
    loading: false,
    error: false
};
const $84e95ca7fc7a04c7$export$884805f5de744f77 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    pluggableItems: $84e95ca7fc7a04c7$var$initialResponse,
    setPluggableItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    lastKeyRef: {
        current: undefined
    }
});
const $84e95ca7fc7a04c7$export$f2618be54b96efae = ({ onDataChanged: onDataChanged, children: children })=>{
    const [pluggableItems, setPluggableItemsBase] = (0, $eJOHy.useState)($84e95ca7fc7a04c7$var$initialResponse);
    const lastKeyRef = (0, $eJOHy.useRef)(undefined);
    const setPluggableItems = (0, $eJOHy.useCallback)((newPluggableItems)=>{
        setPluggableItemsBase(newPluggableItems);
        onDataChanged();
    }, [
        onDataChanged
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            pluggableItems: pluggableItems,
            setPluggableItems: setPluggableItems,
            lastKeyRef: lastKeyRef
        }), [
        pluggableItems,
        setPluggableItems,
        lastKeyRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84e95ca7fc7a04c7$export$884805f5de744f77.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("aWMnb", function(module, exports) {
$parcel$export(module.exports, "useModalDialogCleanupEffect", () => $bedb1e8370874adf$export$586cda8757903229);
$parcel$export(module.exports, "useRegisterModalDialogAnalytics", () => $bedb1e8370874adf$export$fc10f874e8bd1adc);
$parcel$export(module.exports, "useInlineDialogZIndexOverrideLayoutEffect", () => $bedb1e8370874adf$export$84648db9790b0ee);

var $eJOHy = parcelRequire("eJOHy");

var $8sbs2 = parcelRequire("8sbs2");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");
const $bedb1e8370874adf$export$34bf1befb2fab61a = ()=>window.connectHost?.dialog?.close();
const $bedb1e8370874adf$export$cf40ddca756b7741 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const topEl = window.AJS?.LayerManager?.global?.getTopLayer();
    if (topEl == null) return null;
    return topEl.find('iframe')?.[0];
};
const $bedb1e8370874adf$export$586cda8757903229 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useEffect)(()=>()=>{
            try {
                const dialogBeforeClose = $bedb1e8370874adf$export$cf40ddca756b7741();
                $bedb1e8370874adf$export$34bf1befb2fab61a();
                const dialogNow = $bedb1e8370874adf$export$cf40ddca756b7741();
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), dialogBeforeClose && dialogNow ? 'iframe not closed' : 'iframe closed', 'apps', {
                    // Match the unique key part separated by a final __ delimination
                    uniqueKey: dialogBeforeClose?.id.match(/.*(?=__)/)?.[0] ?? dialogBeforeClose?.id,
                    uniqueOpenKey: dialogNow?.id.match(/.*(?=__)/)?.[0] ?? dialogNow?.id
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    error: error,
                    meta: {
                        id: 'issue-navigator-action-pluggable-items.ui.useModalDialogCleanupEffect',
                        packageName: 'jiraIssueNavigatorActionPluggableItems',
                        teamName: 'empanada'
                    }
                });
            }
        }, [
        createAnalyticsEvent
    ]);
};
const $bedb1e8370874adf$export$fc10f874e8bd1adc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const iFrameEstablishedCallback = (0, $eJOHy.useCallback)((payload)=>{
        if (payload.extension.options.moduleType === 'dialogs') (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'iframe established', 'apps', (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(payload.extension.options, [
            'addon_key',
            'isDialog',
            'dialogId',
            'isFullPage',
            'uniqueKey',
            'origin'
        ]));
    }, [
        createAnalyticsEvent
    ]);
    const timeoutIdRef = (0, $eJOHy.useRef)();
    const registerListeners = (0, $eJOHy.useCallback)(()=>{
        // Connect doesn't seem to have a way to notify when it has been registered, so we have to resort to polling
        timeoutIdRef.current = setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (!window.connectHost) registerListeners();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.connectHost.onIframeEstablished(iFrameEstablishedCallback);
        }, 1000);
    }, [
        iFrameEstablishedCallback
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>()=>{
            clearTimeout(timeoutIdRef.current);
            // @ts-expect-error - TS2339 - Unsafe use of Connect's internal API
            if (iFrameEstablishedCallback._wrapper != null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.connectHost?.offIframeEstablished(iFrameEstablishedCallback);
            timeoutIdRef.current = undefined;
        }, [
        iFrameEstablishedCallback,
        registerListeners
    ]);
    return ()=>{
        if (timeoutIdRef.current === undefined) registerListeners();
    };
};
const $bedb1e8370874adf$export$84648db9790b0ee = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { current: styleNode } = (0, $eJOHy.useRef)(document.createElement('style'));
    (0, $eJOHy.useLayoutEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(styleNode);
        styleNode.setAttribute('data-nin-pluggable-items', 'css');
        styleNode.sheet?.insertRule('div.aui-inline-dialog[id^="inline-dialog-webitem-"]{z-index:401}', 0);
        return ()=>{
            if ((0, $7jTnu.fg)('empanada_nin_fix_apps_removechild_error')) styleNode.remove();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.head?.removeChild(styleNode);
        };
    }, [
        styleNode
    ]);
};

});

parcelRegister("607xL", function(module, exports) {
$parcel$export(module.exports, "appsButtonEntryPoint", () => $ec2b18cc1f63e1c2$export$3c2c12ea194b80cf);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ec2b18cc1f63e1c2$export$3c2c12ea194b80cf = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jFqJX")), {
        moduleId: "4b49ee66",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jFqJX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3vnHc").then(()=>parcelRequire('764ST'));

});


parcelRegister("173Wl", function(module, exports) {
$parcel$export(module.exports, "PluggableItemsFilterButton", () => $a8d29cea5eb70ad3$export$7f94e3b48172a1bd);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2k6Pt = parcelRequire("2k6Pt");

var $6ZdYp = parcelRequire("6ZdYp");
const $a8d29cea5eb70ad3$export$7f94e3b48172a1bd = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
        testId: "issue-navigator-action-pluggable-items.ui.filter-button.menu-trigger",
        vcId: "pluggable-items",
        text: formatMessage((0, $6ZdYp.default).pluggableItemsButtonText),
        label: formatMessage((0, $6ZdYp.default).pluggableItemsButtonIconLabel),
        ...props,
        ref: ref
    });
});

});
parcelRegister("6ZdYp", function(module, exports) {
$parcel$export(module.exports, "default", () => $c576eafb2f38cfa7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c576eafb2f38cfa7$var$messages = (0, $7qGN1.defineMessages)({
    pluggableItemsButtonText: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-text",
        "defaultMessage": "Apps"
    },
    pluggableItemsButtonIconLabel: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-icon-label",
        "defaultMessage": "Open pluggable items dropdown"
    }
});
var $c576eafb2f38cfa7$export$2e2bcd8739ae039 = $c576eafb2f38cfa7$var$messages;

});


parcelRegister("lqBEF", function(module, exports) {
$parcel$export(module.exports, "IssueNavigatorActionRuntimeContainer", () => $7e12de990d786a5c$export$7b26d9e8e90b5c69);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $baJzF = parcelRequire("baJzF");

var $52lsd = parcelRequire("52lsd");

var $jZxkB = parcelRequire("jZxkB");

var $lgPrm = parcelRequire("lgPrm");
const $7e12de990d786a5c$export$cfffe81d508bcda3 = ({ app: app, setLoaded: setLoaded, localId: localId, handleError: baseHandleError, closeApp: closeApp })=>{
    // TO DO: add handling for app timeout
    // https://ecosystem-platform.atlassian.net/browse/ARKEN-1786
    // Force render the default error message (instead of the content from the error).
    // By default baseHandleError accepts error message as a parameter
    const handleError = (0, $eJOHy.useCallback)(()=>{
        baseHandleError && baseHandleError();
    }, [
        baseHandleError
    ]);
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            ...(0, $52lsd.getAnalyticsAttributesFromExtension)(app.extension),
            source: 'issue-navigator'
        }), [
        app.extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZxkB.ViewAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgPrm.AsyncIssueNavigatorAction), {
        localId: localId,
        extensionData: app.extensionData,
        extension: app.extension,
        analyticsAttributes: analyticsAttributes,
        onLoad: setLoaded,
        onInitialRender: setLoaded,
        onError: handleError,
        onClose: closeApp
    }));
};
const $7e12de990d786a5c$export$7b26d9e8e90b5c69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        packageName: "software",
        id: "forge-issue-navigator-action-runtime-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baJzF.ForgeAppsRuntimeContainer), {
        forgeAppRenderer: $7e12de990d786a5c$export$cfffe81d508bcda3
    }));

});
parcelRegister("baJzF", function(module, exports) {
$parcel$export(module.exports, "ForgeAppsRuntimeContainer", () => $09e0d61538a81ace$export$db56fac1456ccba8);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $iiemF = parcelRequire("iiemF");

var $lRq8t = parcelRequire("lRq8t");

var $9F3VB = parcelRequire("9F3VB");

var $hO2PV = parcelRequire("hO2PV");
const $09e0d61538a81ace$var$toTargetForgeApp = (app)=>{
    return {
        id: app.id,
        extension: app.extension,
        extensionData: app.action ? {
            ...app.extensionData,
            action: app.action
        } : app.extensionData
    };
};
const $09e0d61538a81ace$var$BaseForgeAppRenderer = ({ app: app, setAppLoaded: setAppLoaded, setAppClose: setAppClose, renderer: ForgeAppRendererComponent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const localId = app.extensionData.action ? `${app.id},action:${app.extensionData.action}` : app.id;
    const setLoaded = (0, $eJOHy.useCallback)(()=>{
        app.isLoading && setAppLoaded(app.id, app.action);
    }, [
        app.id,
        app.action,
        app.isLoading,
        setAppLoaded
    ]);
    const closeApp = (0, $eJOHy.useCallback)(()=>{
        setAppClose(app.id, app.action);
    }, [
        app.id,
        app.action,
        setAppClose
    ]);
    const targetApp = (0, $eJOHy.useMemo)(()=>$09e0d61538a81ace$var$toTargetForgeApp(app), [
        app
    ]);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const handleError = (0, $eJOHy.useCallback)((msg)=>{
        showFlag({
            key: localId,
            type: 'error',
            title: formatMessage((0, $hO2PV.messages).appErrorTitle),
            description: msg ?? formatMessage((0, $hO2PV.messages).appErrorDescription),
            messageId: 'forge-action-apps-controller.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        localId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ForgeAppRendererComponent, {
        localId: localId,
        app: targetApp,
        setLoaded: setLoaded,
        closeApp: closeApp,
        isLoading: app.isLoading,
        handleError: handleError
    });
};
const $09e0d61538a81ace$export$db56fac1456ccba8 = ({ forgeAppRenderer: forgeAppRenderer })=>{
    const [{ openedApps: openedApps }, { setAppLoaded: setAppLoaded, closeApps: closeApps, closeApp: closeApp }] = (0, $9F3VB.useForgeApps)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            closeApps();
        };
    }, [
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiemF.InvisibleDiv), null, openedApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09e0d61538a81ace$var$BaseForgeAppRenderer, {
            key: app.uuid,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            app: app,
            setAppLoaded: setAppLoaded,
            setAppClose: closeApp,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            renderer: forgeAppRenderer
        })));
};

});
parcelRegister("iiemF", function(module, exports) {
$parcel$export(module.exports, "InvisibleDiv", () => $f7376740d95fd4fa$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f7376740d95fd4fa$export$22ef238a7bbeac70 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $f7376740d95fd4fa$export$1442582cffa6fcb7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hO2PV", function(module, exports) {
$parcel$export(module.exports, "messages", () => $09a3dd4827d75799$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $09a3dd4827d75799$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    appErrorTitle: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-title",
        "defaultMessage": "App Error"
    },
    appErrorDescription: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-description",
        "defaultMessage": "An error occurred while loading the app"
    }
});

});


parcelRegister("jZxkB", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $bcffe6cc661d295e$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $bcffe6cc661d295e$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $bcffe6cc661d295e$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
        ...props
    });
const $bcffe6cc661d295e$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("lgPrm", function(module, exports) {
$parcel$export(module.exports, "AsyncIssueNavigatorAction", () => $741e176bbe039316$export$972ed080d6cd6f83);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $av1az = parcelRequire("av1az");

var $ch9En = parcelRequire("ch9En");

var $9W4iD = parcelRequire("9W4iD");
const $741e176bbe039316$export$c83cb1d538aeaee0 = (props)=>{
    const { extension: extension, extensionData: extensionData, ...restProps } = props;
    const extensionDataValue = (0, $eJOHy.useMemo)(()=>({
            ...extensionData,
            type: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $eJOHy.useMemo)(()=>({
            module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
            extensionData: extensionDataValue,
            extension: extension,
            contextToken: (0, $fohjD.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extension,
        extensionDataValue
    ]);
    const bridge = (0, $eJOHy.useMemo)(()=>({
            close: props.onClose
        }), [
        props.onClose
    ]);
    if ((0, $av1az.isNativeUiExtension)(extension) || (0, $av1az.isCustomUIExtension)(extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "issue-navigator-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9W4iD.LazyIssueNavigatorForgeExtension), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        hasModalConsentPrompt: true
    }));
    return null;
};
const $741e176bbe039316$export$972ed080d6cd6f83 = $741e176bbe039316$export$c83cb1d538aeaee0;

});
parcelRegister("9W4iD", function(module, exports) {
$parcel$export(module.exports, "LazyIssueNavigatorForgeExtension", () => $e59a384a326d775a$export$6a4f9722384892ff);

var $aeOhE = parcelRequire("aeOhE");

var $bQWwW = parcelRequire("bQWwW");

const $e59a384a326d775a$var$getModule = ()=>(parcelRequire("hPbje"));
const $e59a384a326d775a$export$6a4f9722384892ff = (0, $aeOhE.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyForPaint)(()=>$e59a384a326d775a$var$getModule().then((module)=>module.IssueNavigatorForgeExtension), {
    ssr: false
}));

});
parcelRegister("hPbje", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1CwLt")
]).then(()=>parcelRequire('fkhtA'));

});






$parcel$global.rlb("cqUOi")
//# sourceMappingURL=ui.a0f5bded.js.map
